"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyzeStatically = void 0;
const static_analyzer_1 = require("./static-analyzer");
Object.defineProperty(exports, "analyzeStatically", { enumerable: true, get: function () { return static_analyzer_1.analyze; } });
//# sourceMappingURL=index.js.map